import { skipToken, useQuery } from "@tanstack/react-query";

import { getRanaApiV1 } from "@nens/rana/api-v1";
import { OurUseQueryOptions } from "@nens/react-query-utils";
import { PaginatedSimulationList, getHCCApi } from "@nens/threedi/openapi-client";

const getHccRevisionSimulationsQuery = (
  revisionId: number | undefined
): OurUseQueryOptions<PaginatedSimulationList> =>
  getRanaApiV1().getQueryOptions({
    queryKey: ["hcc-revision-simulations", revisionId] as const,
    queryFn:
      revisionId !== undefined
        ? () => getHCCApi().simulationsList({ threedimodelRevisionId: revisionId })
        : skipToken,
  });

export const useHccRevisionSimulationsQuery = (revisionId: number | undefined) =>
  useQuery(getHccRevisionSimulationsQuery(revisionId));
